import CreditStatusEnum from "@/bl/enums/CreditStatusEnum";

export default {
    orderOptions: [
        {
            value: "id",
            text: "ID"
        },
        {
            value: "time_remaining:asc",
            text: "Semáforo"
        },
        {
            value: "ppc",
            text: "PPC"
        },
        {
            value: "created_at",
            text: "Fecha creación"
        },
        {
            value: "status",
            text: "Status"
        },
        {
            value: "last_updated_by_supplier",
            text: "Última mod. instalador"
        }
    ],
    status: [
        {
            value: 1,
            text: "Lead"
        },
        {
            value: 2,
            text: "En revisión"
        },
        {
            value: 3,
            text: "Preaprobado"
        },
        {
            value: 4,
            text: "Aprobado"
        },
        {
            value: 5,
            text: "En fondeo"
        },
        {
            value: 6,
            text: "Firma de contratos"
        },
        {
            value: 7,
            text: "En Instalación"
        },
        {
            value: 8,
            text: "Entregado"
        },
        {
            value: 9,
            text: "Rechazado"
        },
        {
            value: 10,
            text: "Cancelado"
        }
    ],
    approveStatus: [
        {
            value: 1,
            text: 'Harán o ya hicieron el pago inicial'
        },
        {
            value: 2,
            text: 'Si quieren el crédito, están en proceso de conseguir...'
        },
        {
            value: 3,
            text: 'Volver a contactar'
        },
        {
            value: 4,
            text: 'Siguen en duda de aceptar el crédito'
        },
        {
            value: 5,
            text: 'No quieren el crédito'
        }
    ],
    revisionStatus: [
        {
            value: 1,
            text: "Lead"
        },
        {
            value: 2,
            text: "En revisión"
        },
        {
            value: 3,
            text: "Preaprobado"
        },
    ],
    opsApprovedStatus: [
        {
            value: 4,
            text: "Aprobado"
        },
        {
            value: 6,
            text: "Firma de contratos"
        },
        {
            value: 7,
            text: "En instalación"
        },
    ],
    error: false,
    errorMessage: '',
    project: {},
    score: {
        min: 0,
        max: 0,
        class: "",
        state: ""
    },
    creditStatus: CreditStatusEnum
}
